export default {
  heroEyebrow: "Centro de recursos Basetao Spreadsheet",
  heroH1: "Basetao Spreadsheet — Encuentra productos, vendedores y recursos de compra más inteligentes",
  heroText:
    "Descubre recursos de Basetao Spreadsheet, guías de investigación de productos, información de vendedores, consejos de control de calidad, guías de envío y recursos prácticos para facilitar la investigación de compras en China.",
  heroCta1: "Basetao Spreadsheet",
  heroCta2: "Comprar ahora",
  heroTrust: "Recurso independiente · Investigación práctica · Guías actualizadas",

  categoriesEyebrow: "Comprar por categoría",
  categoriesTitle: "Explora productos por categoría",
  categoriesText:
    "Elige una categoría a continuación para explorar productos, vendedores y hallazgos del spreadsheet en el sitio principal. Cada enlace se abre en una pestaña nueva.",
  dropdownLabel: "Seleccionar una categoría",
  dropdownPlaceholder: "Elegir una categoría…",
  dropdownGo: "Abrir",

  aboutEyebrow: "Qué es",
  aboutTitle: "¿Qué es un Basetao Spreadsheet?",
  aboutP1:
    "Un Basetao Spreadsheet es una lista o tabla compartida por la comunidad con productos, enlaces, notas de vendedores y observaciones de control de calidad (QC) que usan los compradores que piden a través del agente Basetao. Estas hojas te ayudan a comparar hallazgos, detectar vendedores fiables e investigar artículos antes de comprar.",
  aboutP2:
    "Como una hoja organiza cientos de enlaces de productos en un solo lugar, convierte una búsqueda lenta y dispersa en una forma más rápida y estructurada de investigar ropa, zapatillas, accesorios y más.",
  aboutP3:
    "Trata siempre una hoja como un punto de partida, no como una garantía. Comprueba tú mismo el precio actual, la valoración del vendedor y las condiciones de envío antes de pedir.",

  guidesEyebrow: "Guías y artículos",
  guidesTitle: "Lee nuestras guías originales",
  guidesText:
    "Artículos independientes y originales para ayudarte a investigar productos, entender el QC y tomar mejores decisiones.",
  guide1Title: "Basetao Spreadsheet: guía completa para principiantes",
  guide1Text:
    "Qué es un Basetao Spreadsheet, cómo funciona, categorías populares, consejos de QC y conceptos básicos de envío — todo lo que un principiante necesita saber.",
  guide2Title: "Resumen de categorías de productos",
  guide2Text:
    "Un recorrido rápido por las principales categorías, desde zapatillas y sudaderas hasta bolsos y accesorios.",
  guide3Title: "Cómo leer las fotos de QC",
  guide3Text:
    "Entiende las fotos de QC, las medidas y las señales de alerta que debes revisar antes de aprobar un artículo.",
  guide4Title: "Conceptos básicos de envío",
  guide4Text:
    "Cómo se estima el coste de envío, qué influye en el precio y los factores a comparar entre líneas.",
  readMore: "Leer artículo",

  howEyebrow: "Cómo funciona",
  howTitle: "Investiga mejor en cuatro pasos",
  step1Title: "Encuentra",
  step1Text: "Descubre productos, vendedores y recursos en un solo lugar.",
  step2Title: "Investiga",
  step2Text: "Compara información de productos, vendedores y control de calidad.",
  step3Title: "Verifica",
  step3Text: "Comprueba tú mismo el precio, el envío y las políticas.",
  step4Title: "Decide",
  step4Text: "Pide con mejor información y menos sorpresas.",

  faqEyebrow: "FAQ",
  faqTitle: "Preguntas frecuentes",
  faq1Q: "¿Qué es un Basetao Spreadsheet?",
  faq1A:
    "Es una lista o tabla compartida por la comunidad con enlaces de productos, notas de vendedores y observaciones de QC, que usan los compradores que piden a través del agente Basetao.",
  faq2Q: "¿Es este el sitio oficial de Basetao?",
  faq2A:
    "No. Este es un sitio web informativo independiente, no afiliado ni respaldado por Basetao.",
  faq3Q: "¿Cómo encuentro productos en el sitio principal?",
  faq3A:
    "Usa el menú desplegable o los botones de categoría de esta página. Cada enlace abre la categoría correspondiente en el sitio principal en una pestaña nueva.",
  faq4Q: "¿Cuánto cuesta el envío de Basetao?",
  faq4A:
    "El coste depende del destino, el peso, las dimensiones y el método de envío. Comprueba siempre las tarifas actuales en el sitio principal antes de pedir.",
  faq5Q: "¿Están garantizados los productos?",
  faq5A:
    "No. Una hoja o un enlace de producto no garantiza autenticidad, calidad ni entrega. Investiga primero siempre a los vendedores y la información de QC.",

  finalCtaTitle: "Empieza con Basetao Spreadsheet",
  finalCtaText:
    "Explora recursos de productos, guías de investigación, información de QC y guías de envío en un centro organizado.",
  finalCtaButton: "Explorar Basetao Spreadsheet",
};